"use client"

import * as React from "react"
import { CalendarIcon } from "@radix-ui/react-icons"
import { format } from "date-fns"
import { DateRange } from "react-day-picker"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Calendar } from "../ui/Calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"


type DatePickerWithRangeProps={
  htmlAttributesProps?:React.HTMLAttributes<HTMLDivElement>,
  onSubmitProp:(_:DateRange | undefined)=>void,
  currentValue?:DateRange
}


export function DatePickerWithRange(props: DatePickerWithRangeProps) {
  
  const {htmlAttributesProps,onSubmitProp,currentValue}=props

  const [date, setDate] = React.useState<DateRange | undefined>({
    from: currentValue?.from??undefined,
    to: currentValue?.to??undefined,
  })


  const onSubmit=(range:DateRange|undefined)=>{
    if(!range)return
    const {from,to}=range
    setDate({from,to})
    onSubmitProp({from,to})

    
  }

  return (
    <div className={cn("grid gap-2", htmlAttributesProps?.className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn(
              "w-[300px] justify-start text-left font-normal",
              !date && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} - {format(date.to, 'LLL dd, y')}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={onSubmit}
            numberOfMonths={2}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
